import { render } from "./simpleRegDialog.vue?vue&type=template&id=ba9fab98&scoped=true"
import script from "./simpleRegDialog.vue?vue&type=script&lang=js"
export * from "./simpleRegDialog.vue?vue&type=script&lang=js"

import "./simpleRegDialog.vue?vue&type=style&index=0&id=ba9fab98&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-ba9fab98"

export default script